import { FC } from 'react'
import {
  StyleHeaderWrapper,
  StyleHeading,
  StyleInputSearch,
  StyleSearchWrapper,
} from './style'
import Svg from '@components/svg'
interface SupportHeaderProps {
  onChange: (event: any) => void
}
const SupportHeader: FC<SupportHeaderProps> = ({ onChange }) => {
  return (
    <StyleHeaderWrapper>
      <StyleHeading>Help & Support Chat</StyleHeading>
      <StyleSearchWrapper>
        <Svg svg="search" color={'placeholder'} />
        <StyleInputSearch placeholder="Search..." onChange={onChange} />
      </StyleSearchWrapper>
    </StyleHeaderWrapper>
  )
}

export default SupportHeader
